import { SessionMeeting } from './SessionMeeting';

export enum SessionTypeEnum {
	STANDARD = 'standard',
	FIRST = 'first',
	SECOND = 'second',
	MIDDLE = 'middle',
	PENULTIMATE = 'penultimate',
	LAST = 'last',
}

export type SessionType = 'standard' | 'first' | 'second' | 'middle' | 'penultimate' | 'last';

export interface SessionCommonReflections {
	general: string;
	happyFor: string;
	thingsHard: string;
	other: string;
	result: string;
	techniques: string;
}

export interface SessionMenteeReflections {
	thingsEasy: string;
	nextSteps: string;
	feedback: string;
}

export interface SessionMentorReflections {
	barriers: string;
	selfReflection: string;
	sadFor: string;
}

export type SessionReflections = SessionCommonReflections & (SessionMenteeReflections | SessionMentorReflections);

export interface Session {
	sessionTasks?: any[];
	confirmed: boolean;
	date: Date;
	goal: string;
	mostImportant: string;
	practice: string;
	homework: string;
	id: number;
	files: File[];
	menteeMembershipId: number;
	mentorMembershipId: number;
	rating: number;
	ratingComment?: string;
	menteeRating: number;
	mentorRating: number;
	reflection: SessionReflections;
	pairId: number;
	sessionNumber: number;
	sessionType: SessionType;
	duration: number | null;
	finished: boolean;
	invitationSentAt: Date | null;

	sessionMeetingId: number | null;
	sessionMeeting?: SessionMeeting;
}

export interface ExtendedSession extends Omit<Session, 'ratingComment'> {
	menteeRatingComment?: string;
	mentorRatingComment?: string;
}
